import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

/**
 * Redirect-only para `/confirm/tpcMember/:id/:eventId`.
 *
 * A página standalone de aceite foi descontinuada — o painel de aceite/
 * rejeição vive embutido no card do evento (via `app-tpc-invite-panel`
 * [embedded]=true). Este componente existe apenas para não quebrar
 * links antigos em e-mails de convite já enviados: qualquer entrada na
 * rota redireciona pra página do evento; o painel embutido aparece
 * automaticamente pra quem tem convite pendente.
 *
 * NÃO adicionar UI aqui — este é um endpoint de compatibilidade.
 */
@Component({
  selector: 'app-confirm-tpcinvite-redirect',
  template: '',
})
export class ConfirmTPCInviteRedirectComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe(({ eventId }) => {
      this.router.navigate(['/events', eventId], { replaceUrl: true });
    });
  }
}
